import Rellax from 'rellax';

class Parallax {
    constructor() {
        const imageBoxes = document.querySelectorAll('.parallax');

        //Do not run in episer edit mode
        if (imageBoxes.length && !$('body').data('editmode')) {
            this.initParallax();
        }

    }

    initParallax() {
        new Rellax('.parallax');
    }
}

export default Parallax;